import React from 'react';
import cx from 'classnames';
import { assetUrl } from '~/helpers';

const defaultImageUrl = assetUrl('/assets/images/logos/logo_full.png');

export interface LogoImageProps {
  className?: string;
  imageUrl?: string;
  anchorUrl?: string;
}

const baseCx =
  'flex max-h-[80px] max-w-[220px] h-auto w-auto my-10 self-center';

const extraMdCx = 'xmd:mt-0';

export function LogoImage({
  className,
  imageUrl = defaultImageUrl,
  anchorUrl,
}: LogoImageProps) {
  return (
    <a
      href={anchorUrl}
      className='p-0 m-0 flex w-auto h-auto justify-center'
      target='_blank'
      rel='noreferrer'
    >
      <img className={cx(baseCx, extraMdCx, className)} src={imageUrl} />
    </a>
  );
}
